import React, { useState, useEffect } from 'react';

import './styles.css';

import paymentServices from '../../../../../services/academy/paymentServices';

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import ActivityIndicator from '../../../../../components/ActivityIndicator';
import Notice from '../../../../../components/Notice';
import { FaDollarSign, FaReceipt } from 'react-icons/fa';

function PopupNewPayment(props) {
    const [contractName, setContractName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [enrollments, setEnrollments] = useState([]);

    useEffect(() => {
        if (props.data)
            readEnrollments();
        else if (props.enrollments)
            setEnrollments(props.enrollments);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data, props.enrollments]);

    async function readEnrollments() {
        setFetching(true);
        const response = await paymentServices.getEnrollments(props.data.id);
        setFetching(false);
        if (response.status === 200) {
            setEnrollments(response.data.matriculas
                .filter((item) => item.parcelas_pagas < item.parcelas_totais)
                .map((item) => ({ nome: item.documento.nome, id: item.id })));
        } else
            alert("Erro ao ler matriculas, tente novamente!");
    }

    async function createPayment() {
        console.log(contractName);
        console.log(enrollments.find((item) => item.nome === contractName));
        console.log(selectedFile);
        if (contractName) {
            let enrollment = enrollments.find((item) => item.nome === contractName);
            setUploading(true);
            const response = await paymentServices.postPayment(props.data ? props.data.id : props.studentId, enrollment.id, selectedFile);
            setUploading(false);
            if (response.status === 201) {
                setContractName("");
                setSelectedFile(null);
                if (props.onCreate) props.onCreate();
                props.setVisibility(false);
            } else
                alert("Erro ao registrar pagamento, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaDollarSign />}
            tittle='Novo pagamento'

        >
            {
                props.showUserInfos ?
                    <>
                        <span className='student-new-payment-user-infos'>
                            {
                                props.data && props.data.photo ?
                                    <img src={props.data.photo} alt="foto de usuário" />
                                    :
                                    <div className='user-photo' />
                            }
                            <p><b>{props.data ? props.data.name : 'Usuário'}</b></p>
                        </span>
                        {/* <button onClick={() => console.log(props.data)}>Console</button> */}
                    </>
                    : []
            }

            {
                fetching ?
                    <ActivityIndicator />
                    :
                    (
                        enrollments.length ?
                            <form action="" className='student-new-payment-form'>
                                <Input
                                    label='Contrato*'
                                    type='select'
                                    noFilterOptions
                                    options={enrollments.map(item => item.nome)}
                                    id='student-new-payment-file-name'
                                    placeholder='Selecione um contrato'
                                    onChange={(event) => setContractName(event.target.value)}
                                    value={contractName}
                                />
                                <Input
                                    label={selectedFile ? selectedFile.name : "Anexar comprovante"}
                                    type='file'
                                    accept='application/pdf'
                                    className='student-new-payment-file-input'
                                    id='student-new-payment-file'
                                    icon={<FaReceipt />}
                                    onChange={(event) => setSelectedFile(event.target.files[0])}
                                />
                                <button
                                    type='button'
                                    className='green'
                                    onClick={() => uploading ? alert("Um envio já está em andamento.") : createPayment()}
                                >
                                    {
                                        uploading ?
                                            <ActivityIndicator />
                                            : "Registrar"
                                    }
                                </button>
                            </form>
                            : <Notice>Não há pagamentos em aberto</Notice>
                    )
            }
        </Popup>
    )
}

export default PopupNewPayment;